import * as React from 'react';
import { createSvgIcon } from '@mui/material';
var TwoColumn5050 = createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  id: "Layer_1",
  viewBox: "0 0 48 48",
  x: "0px",
  y: "0px",
  version: "1.1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-Copy-11"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 21.6 43.1 H 2 V 4 h 19.6 V 43.1 Z M 2.5 42.6 h 18.6 V 4.5 H 2.5 V 42.6 Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-Copy-12"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 46 43.1 H 26.4 V 4 H 46 V 43.1 Z M 26.9 42.6 h 18.6 V 4.5 H 26.9 V 42.6 Z"
}))), 'TwoColumn5050');
export { TwoColumn5050 };